import React, { } from "react";
import { HashRouter as Switch, Route, Routes, Navigate } from 'react-router-dom';
import "./App.css";
//auth
import Login from "./screens/user_login_auth/login";
import SignUp from "./screens/user_login_auth/signUp";
import ChangePassword from "./screens/user_login_auth/changePassword";
import Profile from "./screens/user_login_auth/profile";
import PageNotFound from "./screens/user_login_auth/pageNotFound";
import Thankyou from "./screens/user_login_auth/thankyou";
//admin
import RoleList from "./screens/security/role/roleList";
import RoleAU from "./screens/security/role/roleAU";
import UserAU from "./screens/security/user/userAU";
import UserList from "./screens/security/user/userList";
import JuryProfileList from "./screens/admin_module/juryProfile/juryProfileList";
import JuryProfileAU from "./screens/admin_module/juryProfile/juryProfileAU";
import AwardEvent from "./screens/admin_module/awardEvent/awardEvent";
import AwardEventDetail from "./screens/admin_module/awardEvent/awardEventDetail";
//jury 
import Jury_review from "./screens/jury_module/jury_review/jury_review";
//applicant
import ApplicationForm from "./screens/applicant_module/applicationForm/applicationForm";
//report
import ReportList from "./screens/reports/reportList";
import ReportGenerator from "./screens/reports/reportGenerator";
import AdminDashboardList from "./screens/admin_module/adminDashboard/adminDashboardList";
import AdminApplicationList from "./screens/admin_module/adminApplication/adminApplicationList";
import ApplicationMatrix from "./screens/admin_module/applicationMatrix/applicationMatrix";
import JuryBriefingList from "./screens/admin_module/juryBriefing/juryBriefingList";
import AdminApplicationView from "./screens/admin_module/adminApplication/adminApplicationView";
import AdminCircular from "./screens/admin_module/adminCircular/adminCircular";
import ApplicationQuery from "./screens/admin_module/applicationQuery/applicationQuery";
import ProformaList from "./screens/accounts/proforma/proformaList";
import ReceiptList from "./screens/accounts/receipt/receiptList";
import ReceiptManage from "./screens/accounts/receipt/receiptManage";
import ApplicantDashboard from "./screens/applicant_module/applicantDashboard/applicantDashboard";
import Index from "./screens/static/screens/dynamic/Index.js";
import About from "./screens/static/screens/about";
import ChairmanInvite from "./screens/static/screens/chairmanInvite";
import CurrentAwards from "./screens/static/screens/currentAwards";
import PriviousEditions_2022 from "./screens/static/screens/previousEditions_2022";
import PriviousEditions from "./screens/static/screens/previousEditions.js";
import ContactUs from "./screens/static/screens/contactUs";
import Category from "./screens/static/screens/dynamic/category.js";
import Media_coverage from "./screens/static/screens/media_coverage";
import Press_release from "./screens/static/screens/press_release";
import Videos from "./screens/static/screens/videos";
import JuryDashboard from "./screens/jury_module/jury_Dashboard/juryDashboard";
import Submitted from "./screens/user_login_auth/Submitted";
import Jury from "./screens/static/screens/dynamic/jury.js";
import JuryDetails from "./screens/static/screens/dynamic/juryDetails.js";
import TaxInvoiceList from "./screens/accounts/taxInvoice/taxInvoice";
import MediaKit from "./screens/static/screens/MediaKit";
import Associateandpartners from "./screens/static/screens/associateandpartners.js";
import AboutOrganiserIndiaITMESociety from "./screens/static/screens/aboutOrganiserIndiaITMESociety.js";

//cms routes
import CmsHome from "./screens/cms/cmsHome.js";
import CmsHeaderMaster from "./screens/cms/cmsHeaderMaster.js";


function App() {
  return (
    <div className="App">
      <div className="auth-inner">
        <Switch>
          <Routes>
            {/* auth */}
            <Route exact path="/login" element={<Login />} />
            <Route exact path="/signUp" element={<SignUp />} />
            <Route exact path="/profile" element={<Profile />} />
            <Route exact path="/changePassword" element={<ChangePassword />} />
            <Route exact path="/changePassword/:id" element={<ChangePassword />} />
            <Route exact path="/notFound" element={<PageNotFound />} />
            <Route exact path="/thankyou" element={<Thankyou />} />
            <Route path="*" element={<PageNotFound />} />
            {/*Admin*/}
            <Route exact path="/role" element={<RoleList />} />
            <Route exact path="/roleAU" element={<RoleAU />} />
            <Route exact path="/user" element={<UserList />} />
            <Route exact path="/userAU" element={<UserAU />} />
            <Route exact path="/juryProfile" element={<JuryProfileList />} />
            <Route exact path="/juryProfileAU" element={<JuryProfileAU />} />
            <Route exact path="/awardEvent" element={<AwardEvent />} />
            <Route exact path="/awardEventDetail" element={<AwardEventDetail />} />
            <Route exact path="/adminDashboard" element={<AdminDashboardList />} />
            <Route exact path="/adminApplicationList" element={<AdminApplicationList />} />
            <Route exact path="/adminApplicationView" element={<AdminApplicationView />} />
            <Route exact path="/applicationMatrix" element={<ApplicationMatrix />} />
            {/* <Route exact path="/juryBriefing" element={<JuryBriefingList />} /> */}
            <Route exact path="/applicationQuery" element={<ApplicationQuery />} />
            <Route exact path="/proformaList" element={<ProformaList />} />
            <Route exact path="/taxInvoiceList" element={<TaxInvoiceList />} />
            <Route exact path="/receiptList" element={<ReceiptList />} />
            <Route exact path="/receiptManage" element={<ReceiptManage />} />
            {/* Jury Module */}
            <Route exact path="/juryDashboard" element={<JuryDashboard />} />
            <Route exact path="/JuryReview" element={<Jury_review />} />
            {/* applicant */}
            <Route exact path="/applicationForm" element={<ApplicationForm />} />
            <Route exact path="/applicationForm/:status" element={<ApplicationForm />} />
            <Route exact path="/applicantDashboard" element={<ApplicantDashboard />} />
            {/* report */}
            <Route exact path="/reportList" element={<ReportList />} />
            <Route exact path="/reportGenerator" element={<ReportGenerator />} />
            {/* Circular */}
            <Route exact path="/AdminCircular" element={<AdminCircular />} />

            {/* Submitted */}
            <Route exact path="/submitted" element={<Submitted />} />

            {/* static routes */}
            <Route exact path="/" element={<Index />} />
            <Route exact path="/:page" element={<Index />} />
            <Route exact path="/category" element={<Category />} />
            <Route exact path="/jury" element={<Jury />} />
            <Route exact path="/juryDetails" element={<JuryDetails />} />
            <Route exact path="/associateandpartners" element={<Associateandpartners />} />


            <Route exact path="/aboutIndiaITMEAwards" element={<About />} />
            <Route exact path="/aboutOrganiserIndiaITMESociety" element={<AboutOrganiserIndiaITMESociety />} />
            <Route exact path="/chairmanInvite" element={<ChairmanInvite />} />
            <Route exact path="/currentAwards" element={<CurrentAwards />} />
            <Route exact path="/previousEditions_2022" element={<PriviousEditions_2022 />} />
            <Route exact path="/previousEditions" element={<PriviousEditions />} />
            <Route exact path="/contactUS" element={<ContactUs />} />
            <Route exact path="/media_coverage" element={<Media_coverage />} />
            <Route exact path="/press_release" element={<Press_release />} />
            <Route exact path="/videos" element={<Videos />} />
            <Route exact path="/MediaKit" element={<MediaKit />} />

            {/* cms routes */}
            <Route exact path="/cms/manage" element={<CmsHome />} />
            <Route exact path="/cms/manage/:page" element={<CmsHome />} />
            <Route exact path="/cms/header" element={<CmsHeaderMaster />} />
          </Routes>
        </Switch>
      </div>
    </div>
  );
}

export default App;
